import { startCase } from "lodash";
import Typography from "../../../../components/typography/Typography";
import styles from "./classification-image.module.scss";

interface Props {
  classification: string | undefined;
}

const ClassificationImage: React.FC<Props> = ({
  classification = "unknown"
}) => (
  <div className={`${styles.classification_image} ${styles[classification]}`}>
    <div className={styles.wrapper}>
      <img
        className={styles.image}
        src={`${window.tcbase.urls.static}images/classification_images/v2/${classification}.svg`}
        alt={`Threat status: ${classification}`}
        data-testid="sample_classification_image"
      />
      <Typography
        className={`threat-status--${classification} uppercase`}
        variant="body2"
        style={{ fontWeight: 800, lineHeight: "15px" }}
        tag="div"
      >
        {startCase(classification)}
      </Typography>
      {classification === "unknown" && (
        <Typography
          className="threat-status--unknown"
          variant="body4"
          style={{ fontWeight: 600 }}
          tag="div"
        >
          No Threats Found
        </Typography>
      )}
    </div>
  </div>
);

export default ClassificationImage;
